import axios from 'axios';

export default

    axios.create({
        baseURL: 'https://api.game.skillslab.center/',
        
    });